// extracted by mini-css-extract-plugin
export default {"editTabsContainer":"style_editTabsContainer__a8CYV"};